export default {"src":"/_next/static/media/samsungbrowser.b10a3d09.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};